import { useCallback, useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";

// Independently scrollable document list; the Run button stays outside this region in normal flow.
export function DocumentPicker({ docs, selected, onToggle, onSelectAll, onClearAll }) {
  const ref = useRef(null);
  const [more, setMore] = useState(false);
  const update = useCallback((el) => { if (el) setMore(el.scrollHeight - el.scrollTop - el.clientHeight > 4); }, []);
  const setRef = useCallback((el) => { ref.current = el; update(el); }, [update]);
  useEffect(() => { update(ref.current); }, [docs.length, update]);
  const allSelected = docs.length > 0 && selected.length === docs.length;
  return (
    <div className="mt-3" data-testid="document-picker">
      <div className="flex items-center justify-between mb-1">
        <div className="label-cap" data-testid="documents-selection-count">Documents · {selected.length} of {docs.length} selected</div>
        {docs.length > 1 && (
          <div className="flex gap-2 text-[11px]">
            <button type="button" onClick={onSelectAll} disabled={allSelected} className="text-amber-500 hover:text-amber-400 disabled:opacity-40" data-testid="docs-select-all">Select all</button>
            <button type="button" onClick={onClearAll} disabled={!selected.length} className="text-slate-400 hover:text-slate-200 disabled:opacity-40" data-testid="docs-clear-all">Clear</button>
          </div>
        )}
      </div>
      <div className="relative">
        <div ref={setRef} onScroll={(e) => update(e.currentTarget)} className="border border-slate-800 rounded-md p-2 max-h-48 overflow-y-auto overscroll-contain text-xs" data-testid="documents-scroll-list">
          {docs.length ? docs.map((x) => (
            <label key={x.id} className="flex items-center gap-2 py-0.5 cursor-pointer">
              <input type="checkbox" checked={selected.includes(x.id)} onChange={() => onToggle(x.id)} data-testid={`doc-check-${x.id}`} />
              <span className="text-slate-300 truncate">{x.name}</span>
              <span className="text-slate-600 font-mono ml-auto whitespace-nowrap">{x.csi_division}</span>
            </label>
          )) : <span className="text-slate-600">Upload documents first.</span>}
        </div>
        {more && (
          <div className="pointer-events-none absolute inset-x-0 bottom-0 h-8 rounded-b-md bg-gradient-to-t from-slate-950 to-transparent flex items-end justify-center pb-0.5" data-testid="documents-more-indicator">
            <ChevronDown className="w-3 h-3 text-amber-500 animate-bounce" />
          </div>
        )}
      </div>
    </div>
  );
}
